import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from "prop-types";
import HintWrapper from "./HintWrapper";

function mapStateToProps(state) {
    return {
        forcedValidationSteps: state.ui.forcedValidationSteps || []
    };
}

class StepValidationErrors extends Component {

    static propTypes = {
        validationResult: PropTypes.any,
        stepLabel: PropTypes.string,
        forcedValidationSteps: PropTypes.array
    }

    render() {

        const renderErrors = this.props.validationResult !== true && this.props.forcedValidationSteps.includes(this.props.stepLabel);
        let validationErrors = [];

        if (renderErrors && Object.keys(this.props.validationResult).length > 0) {
            Object.keys(this.props.validationResult).forEach((key) => {
                validationErrors.push(
                    <HintWrapper
                        content={this.props.validationResult[key]}
                        theme="error"
                        key={"error_" + key}
                    />
                );
            })
        }

        return validationErrors;
    }
}

export default connect(
    mapStateToProps,
)(StepValidationErrors);



/** WEBPACK FOOTER **
 ** ./src/components/StepValidationErrors.js
 **/